import { EditorCtx } from '@frontend/editor/external-providers';
import { useCallback, useContext, useEffect, useRef } from 'react';

/**
 * 排序把手的畫布拖曳鎖：hover 把手時關閉 reactflow 節點拖曳（避免排序元件時連節點一起拖），離開時恢復。
 * WHY 要有「鎖的歸屬」：若把手在被 hover 時 unmount（排序完成重繪、節點被刪、undo），mouseleave 不會觸發，
 * 畫布會卡在不可拖——舊的「hover 元件即重設拖曳」規則已拆，改在 unmount 復位；但多個 float panel 同時存在時，
 * 沒被 hover 的把手 unmount 不能把別人持有的鎖解掉（Codex review #1490），所以只有自己上過鎖才復位。
 */
export function useFlowDragLock() {
  const { setIsFlowDraggable } = useContext(EditorCtx);
  const ownsLockRef = useRef(false);

  const lock = useCallback(() => {
    ownsLockRef.current = true;
    setIsFlowDraggable(false);
  }, [setIsFlowDraggable]);

  const unlock = useCallback(() => {
    if (!ownsLockRef.current) return;
    ownsLockRef.current = false;
    setIsFlowDraggable(true);
  }, [setIsFlowDraggable]);

  // unmount 時只復位自己持有的鎖
  useEffect(() => unlock, [unlock]);

  return { lock, unlock };
}

export default useFlowDragLock;
